const getAttendanceCount = (data, type, label) => {
  let obj = {};
  label.map((i) => {
    obj[i] = data.filter((j) => j.data.demographicAnswers[type] === i).length;
  })
  return obj;
};

export default getAttendanceCount;